// Enables CSS scroll-behavior for Safari: https://zengabor.github.io/zenscroll/
import 'zenscroll';
